module.exports = __webpack_public_path__ + "static/media/JosefinSans-Regular.aff001b4.ttf";